import { render, staticRenderFns } from "./TaskModuleRules.vue?vue&type=template&id=48628a26&scoped=true"
import script from "./TaskModuleRules.vue?vue&type=script&lang=js"
export * from "./TaskModuleRules.vue?vue&type=script&lang=js"
import style0 from "./TaskModuleRules.vue?vue&type=style&index=0&id=48628a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48628a26",
  null
  
)

export default component.exports